module.exports = __webpack_public_path__ + "8ce105c45840b913b0d6958cf2e012f2.MP3";